export interface ValueRange {
  defaultValue: number | null;
  rangeLower: number | null;
  rangeUpper: number | null;
}

export type PeatDefaultValuesNode =
  | ValueRange
  | { [key: string]: PeatDefaultValuesNode };

export interface PeatDefaultValuesModels {
  [key: string]: PeatDefaultValuesNode;
}

export class PineEconomicAnalysisDefault {
  id: number;
  section: string;
  costGroup?: string;
  item: string;
  defaultValue: number;
  rangeLower: number;
  rangeUpper: number;
}

export function isValueRange(v: unknown): v is ValueRange {
  return (
    !!v &&
    typeof v === 'object' &&
    'defaultValue' in v &&
    'rangeLower' in v &&
    'rangeUpper' in v
  );
}

export function getDefaultVal(obj: any): any {
  if (isValueRange(obj)) {
    return obj.defaultValue;
  }

  const result: Record<string, any> = {};

  for (const [key, val] of Object.entries(obj)) {
    result[key] = getDefaultVal(val);
  }

  return result;
}

export function getDefaultValObj(
  key: string,
  defaultValues: PeatDefaultValuesModels
) {
  const defaultObj = defaultValues[key];
  return Object.fromEntries(
    Object.entries(defaultObj).map(([key, value]: [string, any]) => [
      key,
      value?.defaultValue !== undefined
        ? value.defaultValue
        : Object.fromEntries(
            Object.entries(value).map(
              ([nestedKey, nestedValue]: [string, any]) => [
                nestedKey,
                nestedValue?.defaultValue
              ]
            )
          )
    ])
  );
}
